var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'form-state-item ' + _vm.cls},[_c('div',{staticClass:"form-state-label"},[_c('router-link',{attrs:{"to":{ path: _vm.path }}},[_vm._v("\n      "+_vm._s(_vm.model.domainName)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }